import { freedomApp } from 'freedom-shared';

export const openInsuranceDocument = async (isDev: boolean, link: string) => {
  if (isDev) {
    window.open(link, '_blank')?.focus();
  } else {
    freedomApp.lib.navigate(link);
  }
};
